if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.historyPushed = false;
        this.handlePopState = this.handlePopState.bind(this);

        const prevButton = this.querySelector('.product-media-modal__nav--prev');
        const nextButton = this.querySelector('.product-media-modal__nav--next');
        if (prevButton) prevButton.addEventListener('click', () => this.showAdjacentMedia(-1));
        if (nextButton) nextButton.addEventListener('click', () => this.showAdjacentMedia(1));

        this.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowRight') this.showAdjacentMedia(1);
          if (event.code === 'ArrowLeft') this.showAdjacentMedia(-1);
        });

        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          let touchStartX = 0;
          let touchStartY = 0;

          content.addEventListener(
            'touchstart',
            (event) => {
              touchStartX = event.changedTouches[0].screenX;
              touchStartY = event.changedTouches[0].screenY;
            },
            { passive: true }
          );

          content.addEventListener(
            'touchend',
            (event) => {
              const deltaX = event.changedTouches[0].screenX - touchStartX;
              const deltaY = event.changedTouches[0].screenY - touchStartY;
              const swipeThreshold = 45;

              if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) < Math.abs(deltaY)) return;
              this.showAdjacentMedia(deltaX < 0 ? 1 : -1);
            },
            { passive: true }
          );
        }
      }

      hide(fromPopState) {
        super.hide();
        window.removeEventListener('popstate', this.handlePopState);
        if (!fromPopState && this.historyPushed) {
          this.historyPushed = false;
          history.back();
        } else {
          this.historyPushed = false;
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        // Mobile back gesture/button should close the modal, not navigate away
        // from the product page it was opened on top of.
        this.historyPushed = true;
        history.pushState({ zumiiProductModal: true }, '', location.href);
        window.addEventListener('popstate', this.handlePopState);
      }

      handlePopState() {
        this.historyPushed = false;
        this.hide(true);
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      setActiveMedia(activeMedia) {
        this.getMediaItems().forEach((element) => {
          if (element !== activeMedia) element.classList.remove('active');
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.setActiveMedia(activeMedia);
      }

      showAdjacentMedia(direction) {
        const items = this.getMediaItems();
        if (items.length < 2) return;
        const currentIndex = items.findIndex((element) => element.classList.contains('active'));
        const nextIndex = (currentIndex + direction + items.length) % items.length;
        this.setActiveMedia(items[nextIndex]);
      }
    }
  );
}
